import {basePortalApi as api, CustomValues} from "../basePortalApi";
import {
  PortalExecuteWorkflowCommandValuesDto,
  WorkflowExecutionResultDto,
} from "../workflowTriggers/workflowExecution-api";
import {toastError} from "../../common/utils/toastMessages";
import {t} from "i18next";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    statesGet: build.mutation<StatesGetApiResponse, StatesGetApiArg>({
      query: (arg) => {
        const organizationId = process.env
          .REACT_APP_PORTAL_ORGANIZATION_ID as unknown as number;
        return {
          url: `/api/organizations/${organizationId}/workflowTriggers/${arg.workflowId}`,
          method: "POST",
          body: arg.values,
        };
      },
      async onQueryStarted(args, {queryFulfilled}) {
        try {
          await queryFulfilled;
        } catch (error) {
          toastError(t("toasts.serverError"));
        }
      },
    }),
  }),
  overrideExisting: false,
});
export {injectedRtkApi as portalApi};
export type StatesGetApiResponse =
  /** status 200  */ WorkflowExecutionResultDto;
export type StatesGetApiArg = {
  workflowId: string;
  values?: PortalExecuteWorkflowCommandValuesDto;
};
export type GetStatesQueryValues = {
  countryCode?: string;
};
export type LinkDto = {
  href?: string | null;
  rel?: string | null;
  type?: string | null;
  templated?: boolean | null;
};
export type StateDto = {
  countryCode?: string | null;
  name?: string | null;
  stateCode?: string | null;
  organizationId?: number;
  links?: LinkDto[] | null;
  customValues?: CustomValues | null;
};
export type StateDtoPagedResult = {
  offset?: number;
  limit?: number;
  totalCount?: number;
  items?: StateDto[] | null;
  links?: LinkDto[] | null;
};

export const {useStatesGetMutation} = injectedRtkApi;
